// extracted by mini-css-extract-plugin
export default {"formCard":"FormCard_formCard__ja3Vo","disabledbutton":"FormCard_disabledbutton__ADmdi"};